import React from 'react'
import { MdAudiotrack, MdImage, MdInsertDriveFile, MdVideocam } from 'react-icons/md'

interface MediaTypeIconProps {
  mediaType: 'image' | 'video' | 'file' | string
}

export function renderIcon(mediaType: string) {
  switch (mediaType) {
    case 'image':
      return <MdImage />
    case 'video':
      return <MdVideocam />
    case 'audio':
      return <MdAudiotrack />
    case 'file':
      return <MdInsertDriveFile />
    default:
      return <MdImage />
  }
}

const MediaTypeIcon = ({ mediaType }: MediaTypeIconProps) => {
  return <div className='flex items-center'>{renderIcon(mediaType)}</div>
}

export default MediaTypeIcon
